import { gql } from "@apollo/client";

export const LOG_IN_MERCHANT = gql`
  mutation MerchantLogin($email: String!, $password: String!) {
    merchantLogin(email: $email, password: $password)
  }
`;

export const LOG_IN_MERCHANT_NEW = gql`
  mutation LoginMerchant($email: String!, $password: String!) {
    loginMerchant(email: $email, password: $password)
  }
`;

export const GET_USER = gql`
  query GetMerchantQuery {
    getMerchantQuery {
      _id
      name
      apiKey
      email_id
      role
      phone_number
      user
      trustee_id
      trustee_logo
      school_id
      school_logo
      payouts_enabled
      bank_details {
        account_holder_name
        account_number
        ifsc_code
      }
    }
  }
`;

export const GET_SETTLEMENT_REPORTS = gql`
  query GetMerchantSettlementReports($filters: SettlementFilterInput) {
    getMerchantSettlementReports(filters: $filters) {
      data {
      settlementAmount
      adjustment
      netSettlementAmount
      fromDate
      tillDate
      status
      utrNumber
      settlementDate
      clientId
    }
      total
      page
      limit
    }
  }
`;

export const GET_TRANSACTION_REPORT = gql`
  query GetMerchantTransactionReport(
    $startDate: String
    $endDate: String
    $status: String
    $page: String
    $limit: String
    $isQRCode: Boolean
    $isCustomSearch: Boolean
    $searchFilter: String
    $searchParams: String
    $payment_modes: [String!]
    $gateway: [String!]
    $vendorId: String
  ) {
    getMerchantTransactionReport(
      startDate: $startDate
      endDate: $endDate
      status: $status
      page: $page
      limit: $limit
      isQRCode: $isQRCode
      isCustomSearch: $isCustomSearch
      searchFilter: $searchFilter
      searchParams: $searchParams
      payment_modes: $payment_modes
      gateway: $gateway
      vendor_id: $vendorId
    ) {
      total_pages
      current_page
      transactionReport {
        collect_id
        additional_data
        updatedAt
        createdAt
        payment_time
        order_amount
        transaction_amount
        payment_method
        school_name
        school_id
        status
        student_id
        student_name
        student_email
        student_phone
        student_receipt
        bank_reference
        remarks
        details
        isAutoRefund
        isQRPayment
        commission
        custom_order_id
        payment_time
        gateway
        capture_status
        currency
        vendors_info {
          vendor_id
          percentage
          amount
          name
        }
      }
    }
  }
`;

export const GET_MERCHANT_SINGLE_TRANSACTION_INFO = gql`
  query GetMerchantSingleTransactionReport($collect_id: String!) {
    getMerchantSingleTransactionReport(collect_id: $collect_id) {
      additional_data
      payment_method
      payment_time
      collect_id
      payment_id
      isAutoRefund
      updatedAt
      createdAt
      order_amount
      transaction_amount
      payment_method
      school_name
      school_id
      status
      student_id
      student_name
      class_name
      student_email
      student_phone
      student_receipt
      bank_reference
      remarks
      details
      commission
      custom_order_id
      isQRPayment
      reason
      gateway
      vendors_info {
        vendor_id
        percentage
        amount
        name
      }
      utr_number
      settlement_transfer_time
      capture_status
      virtual_account_id
      isVBAPaymentComplete
      virtual_account_ifsc
      virtual_account_number
      currency
      error_details {
        error_description
        error_reason
        error_source
      }
      payment_origin
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetMerchantPass($email: String!, $password: String!) {
    resetMerchantPass(email: $email, password: $password) {
      msg
    }
  }
`;

export const VERIFY_TOKEN = gql`
  query VerifyMerchantResetPassToken($token: String!) {
    verifyMerchantResetPassToken(token: $token) {
      active
    }
  }
`;

export const RESET_MAILS = gql`
  mutation SendResetPassLinkMerchant($email: String!) {
    sendResetPassLinkMerchant(email: $email) {
      active
    }
  }
`;

export const VALIDATE_LOGIN_OTP = gql`
  mutation ValidateMerchantLoginOtp($otp: String!, $email: String!) {
    validateMerchantLoginOtp(otp: $otp, email: $email)
  }
`;

export const VERIFY_PASSWORD_OTP = gql`
  mutation VerifyPasswordOtp($otp: String!, $password: String!) {
    verifyMerchantPasswordOtp(otp: $otp, password: $password)
  }
`;

export const CREATE_MEMBER = gql`
  mutation CreateMember(
    $name: String!
    $email: String!
    $phone_number: String!
    $access: String!
    $password: String!
  ) {
    createMerchantMember(
      name: $name
      email: $email
      phone_number: $phone_number
      access: $access
      password: $password
    )
  }
`;

export const DELETE_MEMBER = gql`
  mutation DeleteMember($user_id: String!) {
    deleteMerchantMember(user_id: $user_id)
  }
`;

export const GET_ALL_MEMBERS = gql`
  query GetAllMembers {
    getAllMerchantMembers {
      _id
      merchant_id
      name
      email
      phone_number
      access
    }
  }
`;

export const UPDATE_MEMBER_DETAIL = gql`
  mutation UpdateMemberDetails(
    $name: String!
    $user_id: String!
    $email: String!
    $phone_number: String!
  ) {
    updateMerchantMemberDetails(
      name: $name
      user_id: $user_id
      email: $email
      phone_number: $phone_number
    )
  }
`;

export const UPDATE_ACCESS_LEVEL = gql`
  mutation UpdateAccessLevel($user_id: String!, $access: String!) {
    updateMerchantAccessLevel(user_id: $user_id, access: $access)
  }
`;

export const SEND_CHANGE_PASS_OTP = gql`
  mutation SendOtp {
    sendMerchantResetPassOtp
  }
`;

export const UPDATE_MERCHANT_MAIL = gql`
  mutation UpdateMerchantMail($email: String!, $otp: String!) {
    updateMerchantMail(email: $email, otp: $otp)
  }
`;

export const SEND_EDIT_OTP = gql`
  mutation SendOtp {
    sendMerchantEditOtp
  }
`;

export const UPDATE_MERCHANT_PHONE_NUMBER = gql`
  mutation updateMerchantPhoneNumber($phone_number: String!, $otp: String!) {
    updateMerchantPhoneNumber(phone_number: $phone_number, otp: $otp)
  }
`;

export const GET_REFUND = gql`
  query GetOrderRefund($order_id: String!) {
    merchantOrderRefunds(order_id: $order_id) {
      created_at
      order_id
      processed_at
      refund_amount
      refund_arn
      refund_currency
      refund_id
      refund_note
      refund_speed
      refund_status
      refund_type
    }
  }
`;

export const ADD_REMARK = gql`
  mutation AddRemarks($collect_id: String!, $remark: String!) {
    addMerchantRemarks(collect_id: $collect_id, remark: $remark) {
      collect_id
      remarks
    }
  }
`;
export const DELETE_REMARK = gql`
  mutation DeleteRemark($collect_id: String!) {
    deleteMerchantRemark(collect_id: $collect_id)
  }
`;

export const GET_TRANSACTION_UTR = gql`
  query TransactionUtr($date: String!, $school_id: String!) {
    merchantTransactionUtr(date: $date, school_id: $school_id) {
      settlementAmount
      adjustment
      netSettlementAmount
      fromDate
      tillDate
      status
      utrNumber
      settlementDate
      clientId
      trustee
      schoolId
    }
  }
`;

export const GET_ALL_REFUNDS = gql`
  query MerchantRefunds {
    merchantRefunds {
      order_id
      refund_amount
      refund_status
      refund_id
      bank_reference
      created_at
      order_amount
      payment_mode
      pg_refund_id
      processed_at
      refund_arn
      refund_currency
      refund_note
      refund_speed
      refund_type
      school_id
      service_charge
      service_tax
      trustee_id
    }
  }
`;

export const INITIATE_REFUND = gql`
  mutation InitiateRefundRequest(
    $order_id: String!
    $refund_amount: Float!
    $transaction_amount: Float!
    $order_amount: Float!
    $reason: String!
  ) {
    initiateRefundRequest(
      order_id: $order_id
      refund_amount: $refund_amount
      order_amount: $order_amount
      transaction_amount: $transaction_amount
      reason: $reason
    )
  }
`;

export const DELETE_REFUND = gql`
  mutation DeleteRefundRequest($refund_id: String!) {
    deleteRefundRequest(refund_id: $refund_id) {
      trustee_id
      school_id
      order_id
      status
      refund_amount
      order_amount
      transaction_amount
      commission_amount
      reason
    }
  }
`;

export const GET_REFUND_STATUS = gql`
  query GetRefundRequestMerchant($order_id: String!) {
    getRefundRequestMerchant(order_id: $order_id) {
      _id
      trustee_id
      createdAt
      updatedAt
      school_id
      order_id
      status
      refund_amount
      order_amount
      transaction_amount
      custom_id
      reason
      split_refund_details {
        vendor_id
        amount
      }
    }
  }
`;

export const GET_REFUND_REQUESTS = gql`
  query GetRefundRequest(
    $page: Int!
    $limit: Int!
    $startDate: String
    $endDate: String
    $status: String
    $isCustomSearch: Boolean
    $searchQuery: String
  ) {
    getRefundRequests(
      page: $page
      limit: $limit
      startDate: $startDate
      endDate: $endDate
      status: $status
      isCustomSearch: $isCustomSearch
      searchQuery: $searchQuery
    ) {
      totalCountResult
      totalPages
      page
      refundRequests {
        _id
        trustee_id
        createdAt
        updatedAt
        school_id
        order_id
        status
        refund_amount
        order_amount
        transaction_amount
        custom_id
        reason
      }
    }
  }
`;

export const GET_VENDORS = gql`
  query GetMerchantVendor(
    $page: Int!
    $limit: Int!
    $startDate: String
    $endDate: String
    $vendor_id: String
    $custom_id: String
  ) {
    getMerchantVendor(
      page: $page
      limit: $limit
      startDate: $startDate
      endDate: $endDate
      vendor_id: $vendor_id
      custom_id: $custom_id
    ) {
      totalPages
      currentPage
      vendors {
        _id
        trustee_id
        school_id
        name
        email
        phone
        createdAt
        updatedAt
        status
        bank_details {
          account_holder
          account_number
          ifsc
        }
        kyc_info {
          account_type
          business_type
          uidai
          gst
          cin
          pan
          chequeUrl
          passport_number
        }
      }
    }
  }
`;

export const GET_VENDOR_TRANSACTION = gql`
  query GetMerchantVendorTransaction(
    $page: Int!
    $limit: Int!
    $startDate: String
    $endDate: String
    $status: String
    $vendor_id: String
    $custom_id: String
    $order_id: String
    $payment_modes: [String!]
    $gateway: [String!]
  ) {
    getMerchantVendorTransaction(
      page: $page
      limit: $limit
      startDate: $startDate
      endDate: $endDate
      status: $status
      vendor_id: $vendor_id
      custom_id: $custom_id
      order_id: $order_id
      payment_modes: $payment_modes
      gateway: $gateway
    ) {
      vendorsTransaction {
        collect_id
        custom_id
        name
        status
        amount
        createdAt
        updatedAt
        transaction_amount
        payment_method
        gateway
        additional_data
        custom_order_id
        schoolName
      }
      totalPages
      limit
      page
    }
  }
`;

export const INITIATE_SPLIT_REFUND = gql`
  mutation InitiateSplitRefund(
    $order_id: String!
    $refund_amount: Float!
    $order_amount: Float!
    $transaction_amount: Float!
    $reason: String!
    $split_refund_details: [SplitRefundDetails!]!
  ) {
    initiateSplitRefund(
      order_id: $order_id
      refund_amount: $refund_amount
      order_amount: $order_amount
      transaction_amount: $transaction_amount
      reason: $reason
      split_refund_details: $split_refund_details
    )
  }
`;

export const GET_MERCHANT_VENDOR_SETTLEMENT_REPORT = gql`
  query getMerchantVendorSettlementReport(
    $page: Int!
    $limit: Int!
    $start_date: String
    $end_date: String
    $utr: String
    $vendor_id: String
  ) {
    getMerchantVendorSettlementReport(
      page: $page
      limit: $limit
      start_date: $start_date
      end_date: $end_date
      utr: $utr
      vendor_id: $vendor_id
    ) {
      totalCount
      page
      totalPages
      limit
      vendor_settlements {
        _id
        school_id
        vendor_id
        trustee_id
        client_id
        utr
        adjustment
        settlement_amount
        net_settlement_amount
        vendor_transaction_amount
        payment_from
        payment_till
        settled_on
        settlement_id
        settlement_initiated_on
        status
        school_name
        vendor_name
        createdAt
        updatedAt
      }
    }
  }
`;

export const CREATE_MERCHANT_VENDOR = gql`
  mutation createMerchantVendor(
    $vendor_info: VendorInfoInput!
    $chequeBase64: String!
    $chequeExtension: String!
  ) {
    createMerchantVendor(
      vendor_info: $vendor_info
      chequeBase64: $chequeBase64
      chequeExtension: $chequeExtension
    )
  }
`;

export const GET_SINGLE_VENDOR_TRANSACTION = gql`
  query GetSingleMerchantVendorTransaction($order_id: String!) {
    getSingleMerchantVendorTransaction(order_id: $order_id) {
      _id
      collect_id
      custom_id
      name
      school_id
      status
      amount
      createdAt
      updatedAt
      gateway
      additional_data
      trustee_id
      custom_order_id
      payment_method
      bank_reference
      transaction_amount
      payment_detail
      details
      gateway
      payment_origin
    }
  }
`;

export const GET_MERCHANT_DISPUTES = gql`
  query GetMerchantDisputes(
    $page: Int!
    $limit: Int!
    $collect_id: String
    $custom_id: String
    $startDate: String
    $endDate: String
    $dispute_status: String
    $dispute_id: String
  ) {
    getMerchantDisputes(
      page: $page
      limit: $limit
      collect_id: $collect_id
      custom_id: $custom_id
      startDate: $startDate
      endDate: $endDate
      dispute_status: $dispute_status
      dispute_id: $dispute_id
    ) {
      totalCount
      totalPages
      disputes {
        _id
        school_id
        trustee_id
        collect_id
        custom_order_id
        dispute_id
        dispute_type
        reason_description
        dispute_amount
        order_amount
        payment_amount
        dispute_created_date
        dispute_updated_date
        dispute_respond_by_date
        dispute_resolved_at_date
        dispute_status
        dispute_remark
        platform_type
        remarks
        gateway
        case_id
        school_name
        student_name
        bank_reference
        documents {
          file_url
          name
          document_type
        }
      }
    }
  }
`;

export const UPLOAD_DISPUTE_DOCUMENT = gql`
  mutation HandleAndUploadMerchantDisputeDocs(
    $collect_id: String!
    $action: String!
    $files: [UploadedFile!]!
    $reason: String
  ) {
    handleAndUploadMerchantDisputeDocs(
      collect_id: $collect_id
      action: $action
      files: $files
      reason: $reason
    ) {
      success
      message
    }
  }
`;

export const GET_MERCHANT_POS_DETAILS = gql`
  query GetMerchantSchoolPOS {
    getMerchantSchoolPOS {
      _id
      school_id
      trustee_id
      machine_name
      firmware_version
      status
      installation_date
      last_maintenance_at
      machine_details {
        device_mid
        merchant_key
        Device_serial_no
        device_tid
        channel_id
        device_id
      }
    }
  }
`;

export const GET_TRANSACTIONS_OF_SETTLEMENT = gql`
  query GetmerchnatSettlementsTransacions(
    $utr: String!
    $cursor: String!
    $limit: Int!
    $skip: Int!
  ) {
    getMerchantSettlementsTransactions(
      utr: $utr
      cursor: $cursor
      limit: $limit
      skip: $skip
    ) {
      limit
      cursor
      hasMore
      settlements_transactions {
        custom_order_id
        order_id
        event_status
        event_settlement_amount
        order_amount
        event_amount
        event_time
        payment_group
        settlement_utr
        student_id
        student_name
        student_email
        student_phone_no
        school_id
        school_name
        payment_id
      }
    }
  }
`;
export const GET_TRANSACTIONS_OF_VENDOR_SETTLEMENT = gql`
  query GetMerchantVendorSettlementsTransactions(
    $utr: String!
    $limit: Int!
    $cursor: String
    $skip: Int
  ) {
    getMerchantVendorSettlementsTransactions(
      utr: $utr
      limit: $limit
      cursor: $cursor
      skip: $skip
    ) {
      hasMore
      limit
      page
      totalCount
      totalPages
      cursor
      settlements_transactions {
        custom_order_id
        order_id
        event_status
        event_settlement_amount
        order_amount
        event_amount
        event_time
        payment_group
        settlement_utr
        student_id
        school_name
        student_name
        student_email
        student_phone_no
        school_id
        additional_data
        payment_id
      }
    }
  }
`;


export const GET_MERCHANT_BATCH_TRANSACTION = gql`
  query GetMerchantBatchTransactionReport($year: String!) {
    getMerchantBatchTransactionReport(year: $year) {
      _id
      trustee_id
      total_order_amount
      total_transaction_amount
      total_transactions
      month
      year
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_REPORTS = gql`
  query GetMerchantReportLogs($page: Int!, $limit: Int!, $type: String) {
    getMerchantReportsLogs(page: $page, limit: $limit, type: $type) {
      totalCount
      totalPages
      limit
      reports {
        _id
        type
        url
        status
        start_date
        end_date
        createdAt
        updatedAt
      }
    }
  }
`;

export const GENERATE_REPORT = gql`
  mutation GenerateReport(
    $startDate: String
    $endDate: String
    $type: String
    $vendor_list: [String!]
    $dynamic_values: [String!]
  ) {
    generateMerchantReportLog(
      startDate: $startDate
      endDate: $endDate
      type: $type
      vendor_list: $vendor_list
      dynamic_values: $dynamic_values
    )
  }
`;

export const GET_VENDORS_FOR_REPORT = gql`
  query GetVendorsForReport {
    getVendorsForMerchantReport {
      vendor_id
      name
    }
  }
`;

export const CREATE_PAYMENT_FORM = gql`
  mutation CreateMerchantPaymentForm(
    $expires_in: Int!
    $amount: Int
    $student_name: String
    $student_email: String
    $student_phone_no: String
    $student_id: String
    $callback_url: String
    $webhook_url: String
    $amount_type: String
    $additional_data: String
    $school_name: String
    $heading: String
    $base64: String
    $extension: String
    $desc: String
    $fields_show: [String!]
    $split_payment: Boolean
    $form_origin: String
    $vendor_info: [VendorMerchantInfoInputPayment!]
    $drop_down_options: [DropDownOptionInput!]
    $attachment_name: String
    $hasAttachment: Boolean
    $instagram_link: String
    $facebook_link: String
  ) {
    createMerchantPaymentForm(
      expires_in: $expires_in
      amount: $amount
      student_name: $student_name
      student_email: $student_email
      student_phone_no: $student_phone_no
      student_id: $student_id
      callback_url: $callback_url
      webhook_url: $webhook_url
      amount_type: $amount_type
      additional_data: $additional_data
      school_name: $school_name
      heading: $heading
      base64: $base64
      extension: $extension
      desc: $desc
      fields_show: $fields_show
      split_payment: $split_payment
      form_origin: $form_origin
      vendor_info: $vendor_info
      drop_down_options: $drop_down_options
      attachment_name: $attachment_name
      hasAttachment: $hasAttachment
      instagram_link: $instagram_link
      facebook_link: $facebook_link
    ) {
      form_id
      url
    }
  }
`;

export const GET_ACTIVE_VENDORS_BASIC = gql`
  query GetActiveVendorsBasic {
    getActiveVendorsBasic {
      _id
      vendor_id
      name
      email
      phone
      schedule_option
    }
  }
`;

export const GET_MERCHANT_PAYMENT_FORMS = gql`
  query GetMerchantPaymentFormData(
    $form_id: String
    $page: Int
    $limit: Int
    $school_id: String
  ) {
    getMerchantPaymentFormData(
      form_id: $form_id
      page: $page
      limit: $limit
      school_id: $school_id
    ) {
      total
      page
      limit
      totalPages
      data {
        _id
        form_link
        school_id
        trustee_id
        amount
        student_id
        amount_type
        logo
        student_name
        school_name
        student_email
        student_phone_no
        additional_data
        token
        heading
        callback_url
        webhook_url
        desc
        facebook_link
        instagram_link
        banner
        fields_show
        vendor_info {
          vendor_id
          percentage
        }
        split_payments
        form_origin
      }
    }
  }
`;

export const UPLOAD_STUDENTS_CSV = gql`
  mutation UploadStudentsExcelMerchant(
    $data: UploadStudentExcelInput!
    $school_id: String!
    $form_id: String!
  ) {
    uploadStudentsExcelMerchant(data: $data, school_id: $school_id, form_id: $form_id)
  }
`;

export const CREATE_SUBSCRIPTION = gql`
  mutation CreateSubscriptionMerchant($subscription: SubscriptionInput!) {
    createSubscriptionMerchant(subscription: $subscription) {
      message
      error
      data {
        _id
        subscription_id
        subscription_name
        plan_id
        subscription_status
        createdAt
      }
    }
  }
`;

export const GET_SUBSCRIPTIONS_BY_SCHOOL_IDS = gql`
  query MerchantSubscriptionsBySchoolIds(
    $filters: Filters!
    $subscription_id: String
    $school_ids: [String!]
  ) {
    merchantSubscriptionsBySchoolIds(
      filters: $filters
      subscription_id: $subscription_id
      school_ids: $school_ids
    ) {
      message
      error
      total
      data {
        _id
        edv_plan_id
        plan_id
        subscription_id
        subscription_name
        returnUrl
        notification_channel
        session_id_expiry
        cf_session
        cf_subscription_id
        edv_authorization_link
        subscription_status
        subscription_note
        next_schedule_date
        subscription_expiry_time
        subscription_first_charge_time
        createdAt
        updatedAt
        plan_details
        customer_details {
          customer_name
          customer_email
          customer_phone
          customer_bank_account_number
          customer_bank_account_holder_name
          customer_bank_ifsc
          customer_bank_code
          customer_bank_account_type
        }
        authorization_details {
          authorization_amount
          authorization_status
          authorization_amount_refund
          paymnet_methods
        }
      }
    }
  }
`;

export const MANAGE_SUBSCRIPTION = gql`
  mutation ManageMerchantSubscription(
    $manageSubscription: ManageSubscriptionInput!
  ) {
    manageMerchantSubscription(manageSubscription: $manageSubscription) {
      message
      error
      data {
        _id
        edv_plan_id
        plan_id
        subscription_id
        subscription_name
        returnUrl
        notification_channel
        cf_session
        cf_subscription_id
        edv_authorization_link
        subscription_status
        subscription_note
        next_schedule_date
        subscription_expiry_time
        subscription_first_charge_time
        createdAt
        updatedAt
        customer_details {
          customer_name
          customer_bank_account_number
          customer_bank_account_holder_name
          customer_bank_ifsc
          customer_bank_code
          customer_bank_account_type
          customer_email
          customer_phone
        }
        authorization_details {
          authorization_amount
          authorization_amount_refund
        }
      }
    }
  }
`;

export const RAISE_SUBSCRIPTION_PAYMENT = gql`
  mutation RaiseMerchantSubscriptionPayment(
    $input: RaiseSubscriptionPaymentInput!
  ) {
    raiseMerchantSubscriptionPayment(input: $input) {
      cf_payment_id
      payment_id
      subscription_id
      payment_type
      payment_status
      payment_amount
      payment_method
      data
    }
  }
`;

export const GET_PLANS = gql`
  query GetPlansMerchant($filter: PlanFilterInput) {
    getPlansMerchant(filter: $filter) {
      data {
        plan_id
        plan_name
        plan_type
        plan_max_amount
        plan_recurring_amount
        plan_max_cycles
        plan_intervals
        plan_interval_type
        plan_note
        createdAt
      }
      pagination {
        totalCount
        totalPages
        currentPage
        limit
      }
    }
  }
`;

export const CREATE_PLAN = gql`
  mutation CreatePlanMerchant(
    $school_id: String!
    $plan_id: String!
    $plan_name: String!
    $plan_type: PlanTypeEnum!
    $currency: String!
    $plan_max_amount: Float!
    $plan_recurring_amount: Float
    $plan_max_cycles: Int
    $plan_intervals: Int
    $plan_interval_type: PlanInterval
    $plan_note: String
  ) {
    createPlanMerchant(
      data: {
        school_id: $school_id
        plan_id: $plan_id
        plan_name: $plan_name
        plan_type: $plan_type
        currency: $currency
        plan_max_amount: $plan_max_amount
        plan_recurring_amount: $plan_recurring_amount
        plan_max_cycles: $plan_max_cycles
        plan_intervals: $plan_intervals
        plan_interval_type: $plan_interval_type
        plan_note: $plan_note
      }
    ) {
      message
    }
  }
`;

export const GET_PLAN_BY_ID = gql`
  query GetPlanByIdMerchant($id: String!) {
    getPlanByIdMerchant(id: $id) {
      message
      data {
        plan_id
        plan_name
        plan_type
        plan_max_amount
        plan_recurring_amount
        plan_max_cycles
        plan_intervals
        plan_interval_type
        plan_note
        createdAt
      }
    }
  }
`;
